import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Linkedin, Twitter, Instagram } from 'lucide-react';
export const Footer = () => {
  return <footer className="bg-brand-navy pt-24 pb-12 text-white" data-id="element-22">
      <div className="max-w-7xl mx-auto px-6" data-id="element-23">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-12 mb-20" data-id="element-24">
          <div className="lg:col-span-2" data-id="element-25">
            <img src="https://cdn.magicpatterns.com/uploads/7fqogpQfYe6LJMG1Tmc1x4/ChatGPT_Image_Jul_13,_2026,_06_34_58_PM.png" alt="Consilium Advisory Logo" className="h-24 w-auto mb-8 object-contain invert" data-id="element-26" />
            <p className="text-white/50 max-w-sm mb-8 leading-relaxed" data-id="element-27">
              Consilium Advisory is a premier multidisciplinary firm delivering
              strategic advice, disciplined execution, and lasting partnerships
              to a global clientele.
            </p>
            <div className="flex gap-4" data-id="element-28">
              <a href="#" className="text-white/40 hover:text-brand-gold transition-colors" data-id="element-29">
                <Linkedin size={24} data-id="element-30" />
              </a>
              <a href="#" className="text-white/40 hover:text-brand-gold transition-colors" data-id="element-31">
                <Twitter size={24} data-id="element-32" />
              </a>
              <a href="#" className="text-white/40 hover:text-brand-gold transition-colors" data-id="element-33">
                <Instagram size={24} data-id="element-34" />
              </a>
            </div>
          </div>

          <div data-id="element-35">
            <h4 className="text-brand-gold font-bold tracking-widest uppercase text-xs mb-8" data-id="element-36">
              Services
            </h4>
            <ul className="space-y-4 text-white/60 text-sm" data-id="element-37">
              <li data-id="element-38">
                <Link to="/services" className="hover:text-white transition-colors" data-id="element-39">
                  Tax & Accounting
                </Link>
              </li>
              <li data-id="element-40">
                <Link to="/services" className="hover:text-white transition-colors" data-id="element-41">
                  Strategic Advisory
                </Link>
              </li>
              <li data-id="element-42">
                <Link to="/services" className="hover:text-white transition-colors" data-id="element-43">
                  Capital Solutions
                </Link>
              </li>
              <li data-id="element-44">
                <Link to="/services" className="hover:text-white transition-colors" data-id="element-45">
                  CFO Services
                </Link>
              </li>
            </ul>
          </div>

          <div data-id="element-46">
            <h4 className="text-brand-gold font-bold tracking-widest uppercase text-xs mb-8" data-id="element-47">
              Initiatives
            </h4>
            <ul className="space-y-4 text-white/60 text-sm" data-id="element-48">
              <li data-id="element-49">
                <Link to="/about" className="hover:text-white transition-colors" data-id="element-50">
                  Green Harvest Africa
                </Link>
              </li>
              <li data-id="element-51">
                <Link to="/about" className="hover:text-white transition-colors" data-id="element-52">
                  Think Africa
                </Link>
              </li>
              <li data-id="element-53">
                <Link to="/insights" className="hover:text-white transition-colors" data-id="element-54">
                  Research & Policy
                </Link>
              </li>
              <li data-id="element-55">
                <Link to="/about" className="hover:text-white transition-colors" data-id="element-56">
                  Youth Leadership
                </Link>
              </li>
            </ul>
          </div>

          <div data-id="element-57">
            <h4 className="text-brand-gold font-bold tracking-widest uppercase text-xs mb-8" data-id="element-58">
              Newsletter
            </h4>
            <p className="text-white/50 text-xs mb-6" data-id="element-59">
              Receive strategic insights directly to your inbox.
            </p>
            <div className="flex" data-id="element-60">
              <input type="email" placeholder="Email" className="bg-white/5 border-none p-3 text-sm w-full outline-none focus:ring-1 focus:ring-brand-gold" data-id="element-61" />
              <button className="bg-brand-gold p-3" data-id="element-62">
                <ArrowRight size={18} data-id="element-63" />
              </button>
            </div>
          </div>
        </div>

        <div className="pt-12 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-6 text-xs tracking-widest text-white/30 uppercase font-bold" data-id="element-64">
          <div data-id="element-65">© 2026 Consilium Advisory. All Rights Reserved.</div>
          <div className="flex gap-8" data-id="element-66">
            <Link to="/privacy" className="hover:text-white transition-colors" data-id="element-67">
              Privacy Policy
            </Link>
            <Link to="/terms" className="hover:text-white transition-colors" data-id="element-68">
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </footer>;
};